// Decoded from token
export interface AuthClient {
  readonly id: number;
  abilities: {
    umpire?: Record<string, boolean>;
    wicket?: Record<string, boolean>;
  };
  language: string;
  name: string;
  providers: {
    [x: string]: string;
  };
}
